// src/utils/cookies.js

export const setCookie = (name, value, days = 7) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const val = typeof value === 'object' ? JSON.stringify(value) : value;

  document.cookie = `${name}=${encodeURIComponent(val)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
};

export const getCookie = (name) => {
  const raw = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))?.split('=')[1];

  if (!raw) return null;

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return decodeURIComponent(raw);
  }
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

// Plan-specific cookie helpers
export const savePlanSelection = (planId, billingCycle) => {
  setCookie('selected_plan_id', planId, 7);
  setCookie('selected_billing_cycle', billingCycle, 7);
};

export const getPlanSelection = () => {
  return {
    planId: getCookie('selected_plan_id'),
    billingCycle: getCookie('selected_billing_cycle')
  };
};

export const clearPlanSelection = () => {
  deleteCookie('selected_plan_id');
  deleteCookie('selected_billing_cycle');
};